import { Pipe, PipeTransform } from '@angular/core';
import { ProjectPurposeEnum } from '../../enums/project-purpose.enum';

export const ProjectPurposeLabels: { [key: string]: string } = {
  AanbestedingTender: 'Aanbesteding/tender',
  CertificeringBREEAM: 'Certificering (BREEAM)',
  CertificeringGPRGebouw: 'Certificering (GPR Gebouw)',
  CertificeringOverig: 'Certificering (overig)',
  CSRD: 'CSRD',
  HetNieuweNormaalHNN: 'Het Nieuwe Normaal (HNN)',
  Materialenpaspoort: 'Materialenpaspoort',
  Subsidie: 'Subsidie',
  StudieOnderzoek: 'Studie/onderzoek',
  Variant: 'Variant',
  VergunningBBL: 'Vergunning (conform BBL)',
  Overig: 'Overig'
};

@Pipe({
    name: 'purposeLabel',
    standalone: false
})
export class PurposeLabelPipe implements PipeTransform {
  transform(value: number | undefined | null): string {
    if (typeof value !== 'number' || value <= 0) return '';

    const labels = Object.keys(ProjectPurposeEnum)
      .filter(key => isNaN(Number(key))) // exclude reverse mappings
      .filter(key => (value & (ProjectPurposeEnum as any)[key]) === (ProjectPurposeEnum as any)[key])
      .map(key => ProjectPurposeLabels[key])
      .filter(label => !!label); // exclude undefined mappings

    return labels.join('<br>');
  }
}
